import React, { useState } from 'react';
import PublicHeader from '../components/PublicHeader';
import Footer from '../components/Footer';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Mail, Phone, MapPin, Clock } from 'lucide-react';

export default function Contact() {
  const [formData, setFormData] = useState({ name: '', email: '', subject: '', message: '' });

  const handleSubmit = (e) => {
    e.preventDefault();
    alert('Form gönderildi! Yakında sizinle iletişime geçeceğiz.');
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <PublicHeader />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="text-center mb-16">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">İletişim</h1>
          <p className="text-xl text-gray-600">Sorularınız için bize ulaşın</p>
        </div>
        <div className="grid md:grid-cols-2 gap-12">
          <div>
            <h2 className="text-2xl font-bold text-gray-900 mb-6">Bize Ulaşın</h2>
            <div className="space-y-6 mb-8">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-lg bg-orange-100 text-[#FF6000] flex items-center justify-center flex-shrink-0">
                  <Mail className="h-6 w-6" />
                </div>
                <div><h3 className="font-semibold text-gray-900 mb-1">E-posta</h3><p className="text-gray-600">info@aimerkur.com</p><p className="text-gray-600">destek@aimerkur.com</p></div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-lg bg-orange-100 text-[#FF6000] flex items-center justify-center flex-shrink-0">
                  <Phone className="h-6 w-6" />
                </div>
                <div><h3 className="font-semibold text-gray-900 mb-1">Telefon</h3><p className="text-gray-600">+90 (XXX) XXX XX XX</p></div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-lg bg-orange-100 text-[#FF6000] flex items-center justify-center flex-shrink-0">
                  <MapPin className="h-6 w-6" />
                </div>
                <div><h3 className="font-semibold text-gray-900 mb-1">Adres</h3><p className="text-gray-600">İstanbul, Türkiye</p></div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-lg bg-orange-100 text-[#FF6000] flex items-center justify-center flex-shrink-0">
                  <Clock className="h-6 w-6" />
                </div>
                <div><h3 className="font-semibold text-gray-900 mb-1">Çalışma Saatleri</h3><p className="text-gray-600">Pazartesi - Cuma: 09:00 - 18:00</p></div>
              </div>
            </div>
          </div>
          <Card>
            <CardContent className="p-6">
              <h2 className="text-2xl font-bold text-gray-900 mb-6">Mesaj Gönderin</h2>
              <form onSubmit={handleSubmit} className="space-y-4">
                <div><label className="block text-sm font-medium text-gray-700 mb-1">Ad Soyad</label><input type="text" required className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#FF6000] focus:border-transparent" value={formData.name} onChange={(e) => setFormData({...formData, name: e.target.value})} /></div>
                <div><label className="block text-sm font-medium text-gray-700 mb-1">E-posta</label><input type="email" required className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#FF6000] focus:border-transparent" value={formData.email} onChange={(e) => setFormData({...formData, email: e.target.value})} /></div>
                <div><label className="block text-sm font-medium text-gray-700 mb-1">Konu</label><input type="text" required className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#FF6000] focus:border-transparent" value={formData.subject} onChange={(e) => setFormData({...formData, subject: e.target.value})} /></div>
                <div><label className="block text-sm font-medium text-gray-700 mb-1">Mesajınız</label><textarea required rows="4" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#FF6000] focus:border-transparent" value={formData.message} onChange={(e) => setFormData({...formData, message: e.target.value})}></textarea></div>
                <Button type="submit" className="w-full bg-[#FF6000] hover:bg-orange-600">Gönder</Button>
              </form>
            </CardContent>
          </Card>
        </div>
      </div>
      <Footer />
    </div>
  );
}
